import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import {
  ADMIN_ROUTES,
  USER_ROUTES,
  PUBLIC_ROUTES,
} from '../../constants/routeConstants';

const NotFound = () => {
  const location = useLocation();

  const { dashboardPath, isAuthenticated } = useMemo(() => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const token = localStorage.getItem('token');

      const isAuth = user && user.id && token;

      let dashPath = USER_ROUTES.USER_DASHBOARD;
      if (isAuth && user.role === 'super_admin') {
        dashPath = ADMIN_ROUTES.ADMIN_DASHBOARD;
      } else if (isAuth) {
        dashPath = USER_ROUTES.USER_DASHBOARD;
      }

      return { dashboardPath: dashPath, isAuthenticated: isAuth };
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
      return {
        dashboardPath: USER_ROUTES.USER_DASHBOARD,
        isAuthenticated: false,
      };
    }
  }, []);

  const isResetPasswordPath = location.pathname.includes('reset-password');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <Card>
          <CardHeader>
            <CardTitle>Page Not Found</CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <div className="mb-4">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h8m-9-4v4m0 4h9"
                />
              </svg>
            </div>

            <h1 className="text-2xl font-bold text-gray-900 mb-2">404</h1>
            <p className="text-gray-600 mb-6">
              Sorry, we couldn&apos;t find the page you&apos;re looking for.
            </p>

            <div className="space-y-4">
              {isResetPasswordPath ? (
                <Link to={PUBLIC_ROUTES.LOGIN}>
                  <Button className="w-full">Go to Login</Button>
                </Link>
              ) : isAuthenticated ? (
                <Link to={dashboardPath}>
                  <Button className="w-full">Go to Dashboard</Button>
                </Link>
              ) : (
                <div className="space-y-2">
                  <Link to={PUBLIC_ROUTES.LOGIN}>
                    <Button className="w-full">Go to Login</Button>
                  </Link>
                  <Link to={PUBLIC_ROUTES.SIGNUP}>
                    <Button variant="outline" className="w-full">
                      Create Account
                    </Button>
                  </Link>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default NotFound;
